import { render, staticRenderFns } from "./SurveyQuestionHeader.vue?vue&type=template&id=2e9cb4aa&scoped=true&"
import script from "./SurveyQuestionHeader.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestionHeader.vue?vue&type=style&index=0&id=2e9cb4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9cb4aa",
  null
  
)

export default component.exports